module.exports = __webpack_public_path__ + "img/cashpay-charge.37f6b3f4.svg";